import React, { Component } from "react";
import SelectDropDownForm from "./selectDropDownForm";
import commonContext, { AppContext } from "../../../context/common";
import VehicleInfoHeader from "./vehicleInfoHeader";
import { leadType } from "../../../../app";
import { ALDDApis } from "../../../../ddAl/apis/aLDDApis";
import { Utilities } from "../../../utils/utilities";

interface IProps {
    contextState?: object;
    changeState?: Function;
}
interface IState {}
export class VehicleInfo extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: ALDDApis;
    setLead: Function;
    utils: Utilities;
    base: any;
    async componentDidMount() {
        this.apis = (this.context as AppContext).apis as ALDDApis;
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;
    }
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;
        this.base = (this.context as AppContext).base;
        return (
            <>
                <VehicleInfoHeader />
                {this.base == "dd-al" ? (
                    <>
                        <div className="flex flex-wrap w-full">
                            <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                                    State of Registration
                                </label>
                                <p className="font-22px text-black">
                                    {this.lead.pdPresentState}
                                </p>
                            </div>
                            <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                                    City
                                </label>
                                <p className="font-22px text-black">
                                    {this.lead.pdPresentCity}
                                </p>
                            </div>
                            <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                                    Manufacturer
                                </label>
                                <p className="font-22px text-black">
                                    {this.lead.manufacturer}
                                </p>
                            </div>
                            <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                                    Car Make
                                </label>
                                <p className="font-22px text-black">
                                    {this.lead.make}
                                </p>
                            </div>
                            <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                                    Car Model
                                </label>
                                <p className="font-22px text-black">
                                    {this.lead.model}
                                </p>
                            </div>
                            <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                <SelectDropDownForm
                                    title="Dealer"
                                    errorText="Please select Dealer"
                                    name="dealerSupplierId"
                                    handlerOnChange={(e) =>
                                        this.setLead({
                                            dealerSupplierId: e.target.value,
                                        })
                                    }
                                    value={this.lead?.dealerSupplierId}
                                />
                            </div>
                            <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                <label
                                    htmlFor=""
                                    className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500"
                                >
                                    Ex-showroom price quoted by the dealer
                                </label>
                                <span className="absolute rupees-code text-base md:text-base lg:text-lg xl:text-xl text-gray-500 WebRupee">
                                    Rs.
                                </span>
                                <p className="font-22px text-black pl-5">
                                    {this.utils.currencyFormat(
                                        this.lead.avgCost
                                    )}
                                </p>{" "}
                            </div>
                        </div>
                    </>
                ) : (
                    ""
                )}
                {this.base === "qm-10-seconds" ? (
                    <>
                        <div className="relative w-full mb-8">
                            <div className="relative w-full rounded-lg lighter-blue-2 px-3 py-3 md:px-5 md:py-5 xl:px-8 xl:py-8">
                                <div className="flex flex-wrap w-full">
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <label className="openSans-Reg text-gray-500 text-xs md:text-base lg:text-base xl:text-base">
                                            Existing Loan Account Number
                                        </label>
                                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                            {
                                                this.lead
                                                    .existingLoanAccountNumber
                                            }
                                        </p>
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                        <label className="openSans-Reg text-gray-500 text-xs md:text-base lg:text-base xl:text-base">
                                            Model Description
                                        </label>
                                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                            {this.lead.modelDescription}
                                        </p>
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <label className="openSans-Reg text-gray-500 text-xs md:text-base lg:text-base xl:text-base">
                                            Chassis Number
                                        </label>
                                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                            {this.lead.chassisNumber}
                                        </p>
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                        <label className="openSans-Reg text-gray-500 text-xs md:text-base lg:text-base xl:text-base">
                                            Engine Number
                                        </label>
                                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                            {this.lead.engineNumber}
                                        </p>
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <label className="openSans-Reg text-gray-500 text-xs md:text-base lg:text-base xl:text-base">
                                            Vehicle Registration Number/Vehicle
                                            Number
                                        </label>
                                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                            {
                                                this.lead
                                                    .registrationNumberVehicleNumber
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    ""
                )}
            </>
        );
    }
}

export default VehicleInfo;
